import Grid from '@material-ui/core/Grid';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import React from 'react';

import { useOriginatorContext } from './register-context';
import { GridUpperPanelProps } from './register-types';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      minHeight: 60,
      backgroundColor: theme.palette.secondary.main,
      boxShadow: theme.shadows[1],
    },
    body: {
      display: 'flex',
      color: 'white',
      textDecoration: 'none',
      fontSize: '14px !important',
      fontWeight: 700,
      lineHeight: '60px',
    },
    bodyItem: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: '16px',
      marginRight: '15px',
      fontWeight: 'bold',
      textTransform: 'uppercase',
    },
    bodyItemLabel: {
      marginRight: '5px',
    },
    bodyItemValue: {
      width: '140px',
    },
    textRoot: {
      backgroundColor: 'white',
    },
    textInput: {
      margin: '0 5px',
    },
  })
);

export const GridUpperPanel: React.FC<GridUpperPanelProps> = () => {
  const classes = useStyles();

  const { originator } = useOriginatorContext();

  return (
    <Grid container className={classes.root}>
      <Grid item xs={12} className={classes.body}>
        <div className={classes.bodyItem}>
          <span className={classes.bodyItemLabel}>
            {originator?.originatorClassLabel}
            {originator?.subClassLabel ? ` > ${originator?.subClassLabel}` : ''}
          </span>
        </div>
      </Grid>
    </Grid>
  );
};
